import React from 'react';
import {EditorContent, useEditor} from "@tiptap/react";
import StarterKit from "@tiptap/starter-kit";
import './style.css';

type Props = {
    html?: string;
};

export default function RichTextViewer({html = ""}: Props) {
    const editor = useEditor({
        extensions: [StarterKit],
        content: html || "",
        editable: false
    });

    if (!editor) return null;

    return (
        <div className='rtx-viewer' style={{marginTop: 6}}>
            <EditorContent editor={editor}/>
        </div>
    );
}